import { h, defineComponent } from 'vue';
import { container } from '@/ui/components';
import Invoices from '@/_legacy/views/Subscriptions/Invoices.vue';

export const InvoicesPage = defineComponent({
  name: 'InvoicesPage',
  setup() {
    return function render() {
      return container(
        [
          container([
            // @ts-ignore
            h(Invoices, { class: 'legacy' }),
          ], 'medium'),
        ],
      );
    };
  },
});
